
//Cocopeat Blocks 5Kg
import block5a from "../assets/products/Cocopeat Blocks/5Kg/3inarow.png";
import block5b from "../assets/products/Cocopeat Blocks/5Kg/rows.png";
import block5c from "../assets/products/Cocopeat Blocks/5Kg/rows_blocks.png";
import block5d from "../assets/products/Cocopeat Blocks/5Kg/single_watermark.png";
import block5e from "../assets/products/Cocopeat Blocks/5Kg/1_block.jpg";
import block5f from "../assets/products/Cocopeat Blocks/5Kg/2_blocks.jpg";
import block5g from "../assets/products/Cocopeat Blocks/5Kg/mini_rows.jpg";
import block5h from "../assets/products/Cocopeat Blocks/5Kg/rows_copy.jpg";
import block5i from "../assets/products/Cocopeat Blocks/5Kg/coir pith block 2.jpg";
import block5j from "../assets/products/Cocopeat Blocks/5Kg/packed.jpg";

//Coco Chips Blocks
import chips1 from "../assets/products/Coco Chips Blocks/single.jpg";
import chips2 from "../assets/products/Coco Chips Blocks/rows.jpg";
import chips3 from "../assets/products/Coco Chips Blocks/rows_good_color.jpg";
import chips4 from "../assets/products/Coco Chips Blocks/blocks_rows.jpg";
import chips5 from "../assets/products/Coco Chips Blocks/packed.jpg";
import chips6 from "../assets/products/Coco Chips Blocks/packed_with_powder.jpg"; 

//Cocopeat Blocks 2Kg
import block2a from "../assets/products/Cocopeat Blocks/2Kg/blocks.png";
import block2b from "../assets/products/Cocopeat Blocks/2Kg/row.png";
import block2c from "../assets/products/Cocopeat Blocks/2Kg/packed.jpg";

//Cocopeat Blocks 1Kg
import block1a from "../assets/products/Cocopeat Blocks/1Kg/image2.jpg";
import block1b from "../assets/products/Cocopeat Blocks/1Kg/image3.jpg"; 
import block1c from "../assets/products/Cocopeat Blocks/1Kg/image4.jpg";
import block1d from "../assets/products/Cocopeat Blocks/1Kg/image5.jpg";
import block1e from "../assets/products/Cocopeat Blocks/1Kg/double.jpg"; 

//Cocopeat Blocks 650g
import block650g from "../assets/products/Cocopeat Blocks/650g/image2.jpg";
import block650g2 from "../assets/products/Cocopeat Blocks/650g/image3.jpg";
import block650g3 from "../assets/products/Cocopeat Blocks/650g/image1.jpg";
import block650g4 from "../assets/products/Cocopeat Blocks/650g/image4.png";
import block650g5 from "../assets/products/Cocopeat Blocks/650g/image5.png";
import block650g6 from "../assets/products/Cocopeat Blocks/650g/image6.png";
import block650g7 from "../assets/products/Cocopeat Blocks/650g/image7.png";
import block650g8 from "../assets/products/Cocopeat Blocks/650g/image8.png";

//Coir Fibre 120 Kg Bale
import coirFibre120Kg from "../assets/products/Coir Fibre/120 Kg Bale/image1.png";
import coirFibre120Kg2 from "../assets/products/Coir Fibre/120 Kg Bale/image2.png";
import coirFibre120Kg3 from "../assets/products/Coir Fibre/120 Kg Bale/image3.png";
import coirFibre120Kg4 from "../assets/products/Coir Fibre/120 Kg Bale/image4.png";

//Coir Fibre 30Kg Bale
import coirFibre30Kg from "../assets/products/Coir Fibre/30 Kg Bale/image1.jpg";
import coirFibre30Kg2 from "../assets/products/Coir Fibre/30 Kg Bale/image2.jpg";
import coirFibre30Kg3 from "../assets/products/Coir Fibre/30 Kg Bale/image3.jpg";
import coirFibre30Kg4 from "../assets/products/Coir Fibre/30 Kg Bale/image4.jpg";

// Coir Yarn - 2 Ply 7 mm
import ply7mm22_1 from "../assets/products/Coir Yarn/2 Ply 7 mm/2 Ply 7mm 22Inches (HALF Kg PCS) 32.jpg";
import ply7mm22_2 from "../assets/products/Coir Yarn/2 Ply 7 mm/2 Ply 7mm 22Inches (HALF Kg PCS) 20.jpg";
import ply7mm22_3 from "../assets/products/Coir Yarn/2 Ply 7 mm/2 Ply 7mm 22Inches (HALF Kg PCS) 21.jpg";
import ply7mm22_4 from "../assets/products/Coir Yarn/2 Ply 7 mm/2 Ply 7mm 22Inches (HALF Kg PCS) 23.jpg";
import ply7mm22_5 from "../assets/products/Coir Yarn/2 Ply 7 mm/2 Ply 7mm 22Inches (HALF Kg PCS) 25.jpg";
import ply7mm22_6 from "../assets/products/Coir Yarn/2 Ply 7 mm/2 Ply 7mm 22Inches (HALF Kg PCS) 26.jpg";
import ply7mm22_7 from "../assets/products/Coir Yarn/2 Ply 7 mm/2 Ply 7mm 22Inches (HALF Kg PCS) 27.jpg";
import ply7mm22_8 from "../assets/products/Coir Yarn/2 Ply 7 mm/2 Ply 7mm 22Inches (HALF Kg PCS) 28.jpg";
import ply7mm22_9 from "../assets/products/Coir Yarn/2 Ply 7 mm/2 Ply 7mm 22Inches (HALF Kg PCS) 30.jpg";
import ply7mm22_10 from "../assets/products/Coir Yarn/2 Ply 7 mm/2 Ply 7mm 22Inches (HALF Kg PCS) 31.jpg";
import ply7mm22_11 from "../assets/products/Coir Yarn/2 Ply 7 mm/2 Ply 7mm 22Inches (HALF Kg PCS) 17.jpg";
import ply7mm22_12 from "../assets/products/Coir Yarn/2 Ply 7 mm/2 Ply 7mm 22Inches (HALF Kg PCS).jpg";
import ply7mm22_13 from "../assets/products/Coir Yarn/2 Ply 7 mm/2 Ply 7mm 22Inches (One Kg PCS) 1.jpg";
import ply7mm22_14 from "../assets/products/Coir Yarn/2 Ply 7 mm/2 Ply 7mm 22Inches 1.jpg";
import ply7mm22_15 from "../assets/products/Coir Yarn/2 Ply 7 mm/2 Ply 7mm 22Inches.jpg";
import ply7mm30_1 from "../assets/products/Coir Yarn/2 Ply 7 mm/2 Ply 7mm 30 Inches (HALF Kg PCS) 7.jpg";
import ply7mm30_2 from "../assets/products/Coir Yarn/2 Ply 7 mm/2 Ply 7mm 30 Inches.jpg";
import ply7mm30_3 from "../assets/products/Coir Yarn/2 Ply 7 mm/2 Ply 7mm 30 Inches(HALF Kg PCS) 1.jpg";
import ply7mm30_4 from "../assets/products/Coir Yarn/2 Ply 7 mm/2 Ply 7mm 30 Inches(HALF Kg PCS) 2.jpg";
import ply7mm30_5 from "../assets/products/Coir Yarn/2 Ply 7 mm/2 Ply 7mm 30 Inches(HALF Kg PCS) 3.jpg";

// Coir Yarn - 2 Ply 5 mm
import ply5mm_1 from "../assets/products/Coir Yarn/2 Ply 5 mm/2 Ply 5mm 48 Inches 40 Feet.jpg";
import ply5mm_2 from "../assets/products/Coir Yarn/2 Ply 5 mm/2 Ply 5mm 48 Inches 40 Feet 2.jpg";
import ply5mm_3 from "../assets/products/Coir Yarn/2 Ply 5 mm/2 Ply 5mm 48 Inches 40 Feet 3.jpg";
import ply5mm_4 from "../assets/products/Coir Yarn/2 Ply 5 mm/2 Ply 5mm 48 Inches 40 Feet 5.jpg";
import ply5mm_5 from "../assets/products/Coir Yarn/2 Ply 5 mm/2 Ply 5mm 48 Inches 40 Feet 7.jpg";

// Coir Yarn - 2 Ply 4 mm
import ply4mm_1 from "../assets/products/Coir Yarn/2 Ply 4 mm/2 Ply 4mm 18 Inches 40 Feet 1.jpg";
import ply4mm_2 from "../assets/products/Coir Yarn/2 Ply 4 mm/2 Ply 4mm 18 Inches 40 Feet 2.jpg";
import ply4mm_3 from "../assets/products/Coir Yarn/2 Ply 4 mm/2 Ply 4mm 18 Inches 40 Feet 3.jpg";
import ply4mm_4 from "../assets/products/Coir Yarn/2 Ply 4 mm/2 Ply 4mm 18 Inches 40 Feet 4.png";
import ply4mm_5 from "../assets/products/Coir Yarn/2 Ply 4 mm/2 Ply 4mm 18 Inches 40 Feet 5.png";
import ply4mm_6 from "../assets/products/Coir Yarn/2 Ply 4 mm/2 Ply 4mm 18 Inches 40 Feet 6.png";
import ply4mm_7 from "../assets/products/Coir Yarn/2 Ply 4 mm/2 Ply 4mm 18 Inches 40 Feet 7.png";
import ply4mm_8 from "../assets/products/Coir Yarn/2 Ply 4 mm/2 Ply 4mm 18 Inches 40 Feet 8.png";
import ply4mm_9 from "../assets/products/Coir Yarn/2 Ply 4 mm/2 Ply 4mm 18 Inches 40 Feet 9.png";

// Coir Yarn - 2 Ply 3 mm
import ply3mm_1 from "../assets/products/Coir Yarn/2 Ply 3 mm/2 Ply 3mm 18 Inches 40 Feet 1.jpg";
import ply3mm_2 from "../assets/products/Coir Yarn/2 Ply 3 mm/2 Ply 3mm 18 Inches 40 Feet 6.jpg";
import ply3mm_3 from "../assets/products/Coir Yarn/2 Ply 3 mm/2 Ply 3mm 18 Inches 40 Feet 7.jpg";
import ply3mm_4 from "../assets/products/Coir Yarn/2 Ply 3 mm/2 Ply 3mm 18 Inches 40 Feet 8.jpg";
import ply3mm_5 from "../assets/products/Coir Yarn/2 Ply 3 mm/2 Ply 3mm 18 Inches 40 Feet 9.jpg";
import ply3mm_6 from "../assets/products/Coir Yarn/2 Ply 3 mm/2 Ply 3mm 18 Inches 40 Feet 10.jpg";
import ply3mm_7 from "../assets/products/Coir Yarn/2 Ply 3 mm/2 Ply 3mm 18 Inches 40 Feet 11.jpg";
import ply3mm_8 from "../assets/products/Coir Yarn/2 Ply 3 mm/2 Ply 3mm 18 Inches 40 Feet 12.jpg";
import ply3mm_9 from "../assets/products/Coir Yarn/2 Ply 3 mm/2 Ply 3mm 18 Inches 40 Feet 13.jpg";
import ply3mm_10 from "../assets/products/Coir Yarn/2 Ply 3 mm/2 Ply 3mm 18 Inches 40 Feet 14.jpg";

// Coir Yarn - 2 Ply 15 Feet / 18 Feet or Double Piece
import doublePiece1 from "../assets/products/Coir Yarn/2 Ply 15 Feet : 18 Feet_Double Piece/Double Piece 1.png";
import doublePiece2 from "../assets/products/Coir Yarn/2 Ply 15 Feet : 18 Feet_Double Piece/Double Piece 2.png";
import doublePiece3 from "../assets/products/Coir Yarn/2 Ply 15 Feet : 18 Feet_Double Piece/Double Piece 3.png";
import doublePiece4 from "../assets/products/Coir Yarn/2 Ply 15 Feet : 18 Feet_Double Piece/Double Piece 4.png";
import doublePiece5 from "../assets/products/Coir Yarn/2 Ply 15 Feet : 18 Feet_Double Piece/Double Piece 5.png";
import doublePiece6 from "../assets/products/Coir Yarn/2 Ply 15 Feet : 18 Feet_Double Piece/Double Piece 6.png";
import doublePiece7 from "../assets/products/Coir Yarn/2 Ply 15 Feet : 18 Feet_Double Piece/Double Piece 7.png";
import doublePiece8 from "../assets/products/Coir Yarn/2 Ply 15 Feet : 18 Feet_Double Piece/Double Piece 8.png";
import doublePiece9 from "../assets/products/Coir Yarn/2 Ply 15 Feet : 18 Feet_Double Piece/Double Piece 9.png";
import doublePiece10 from "../assets/products/Coir Yarn/2 Ply 15 Feet : 18 Feet_Double Piece/Double Piece 10.png";
import doublePiece11 from "../assets/products/Coir Yarn/2 Ply 15 Feet : 18 Feet_Double Piece/Double Piece 11.jpg";
import doublePiece12 from "../assets/products/Coir Yarn/2 Ply 15 Feet : 18 Feet_Double Piece/Double Piece 12.png";

// Coir Yarn - 3 Ply 15 Feet / 18 Feet
import ply3_15_18_1 from "../assets/products/Coir Yarn/3 Ply 15 Feet : 18 Feet/3 Ply 15 Feet 1.png";
import ply3_15_18_2 from "../assets/products/Coir Yarn/3 Ply 15 Feet : 18 Feet/3 Ply 15 Feet 2.png";
import ply3_15_18_3 from "../assets/products/Coir Yarn/3 Ply 15 Feet : 18 Feet/3 Ply 15 Feet 3.png";
import ply3_15_18_4 from "../assets/products/Coir Yarn/3 Ply 15 Feet : 18 Feet/3 Ply 15 Feet 4.png";
import ply3_15_18_5 from "../assets/products/Coir Yarn/3 Ply 15 Feet : 18 Feet/3 Ply 15 Feet 5.png";
import ply3_15_18_6 from "../assets/products/Coir Yarn/3 Ply 15 Feet : 18 Feet/3 Ply 15 Feet 6.png";

// Coir Rope - 8 Ply / 10 Ply (Vadam)
import vadam1 from "../assets/products/Coir Rope/8 Ply : 10 Ply (Vadam)/8 Ply 1.jpg";
import vadam2 from "../assets/products/Coir Rope/8 Ply : 10 Ply (Vadam)/8 Ply 2.jpg";
import vadam3 from "../assets/products/Coir Rope/8 Ply : 10 Ply (Vadam)/8 Ply 3.jpg";

// Coir Rope - Loose Twisted Spooling
import looseTwisted1 from "../assets/products/Coir Rope/Loose Twisted Spooling/Loose Twisted Spooling 1.jpg";
import looseTwisted2 from "../assets/products/Coir Rope/Loose Twisted Spooling/Loose Twisted Spooling 2.jpg";
import looseTwisted3 from "../assets/products/Coir Rope/Loose Twisted Spooling/Loose Twisted Spooling.jpg";

//Cocopeat Loose Powder
import loosePowder from "../assets/products/Cocopeat Powder/Loose Powder/image1.png";
import loosePowder2 from "../assets/products/Cocopeat Powder/Loose Powder/image2.png";
import loosePowder3 from "../assets/products/Cocopeat Powder/Loose Powder/image3.png";
import loosePowder4 from "../assets/products/Cocopeat Powder/Loose Powder/image4.png";

//Cocopeat Powder 25Kg Bale
import cocopeatPowder25Kg1 from "../assets/products/Cocopeat Powder/25 Kg Bale/image1.jpg";
import cocopeatPowder25Kg2 from "../assets/products/Cocopeat Powder/25 Kg Bale/image2.jpg";
import cocopeatPowder25Kg3 from "../assets/products/Cocopeat Powder/25 Kg Bale/image3.jpg";
import cocopeatPowder25Kg4 from "../assets/products/Cocopeat Powder/25 Kg Bale/image4.jpg";

//Organic Fertilizers - Fish Amino Acid
import fishAminoAcid from "../assets/products/Organic Fertilizers/Fish Amino Acid/image1.png";
import fishAminoAcid2 from "../assets/products/Organic Fertilizers/Fish Amino Acid/image2.png";
import fishAminoAcid3 from "../assets/products/Organic Fertilizers/Fish Amino Acid/image3.png";
import fishAminoAcid4 from "../assets/products/Organic Fertilizers/Fish Amino Acid/image4.png";
import fishAminoAcid5 from "../assets/products/Organic Fertilizers/Fish Amino Acid/image5.png";
import fishAminoAcid6 from "../assets/products/Organic Fertilizers/Fish Amino Acid/image6.png";
import fishAminoAcid7 from "../assets/products/Organic Fertilizers/Fish Amino Acid/image7.png";
import fishAminoAcid8 from "../assets/products/Organic Fertilizers/Fish Amino Acid/image8.png";
import fishAminoAcid9 from "../assets/products/Organic Fertilizers/Fish Amino Acid/image9.png";
import fishAminoAcid10 from "../assets/products/Organic Fertilizers/Fish Amino Acid/image10.png";

//Organic Fertilizers - Neem Cake Powder
import ncp1 from "../assets/products/Organic Fertilizers/Neem Cake Powder/ncp1.jpg";
import neemCakePowder from "../assets/products/Organic Fertilizers/Neem Cake Powder/image1.png";
import neemCakePowder2 from "../assets/products/Organic Fertilizers/Neem Cake Powder/image2.png";
import neemCakePowder3 from "../assets/products/Organic Fertilizers/Neem Cake Powder/image3.png";
import neemCakePowder3a from "../assets/products/Organic Fertilizers/Neem Cake Powder/image3a.png";
import neemCakePowder4 from "../assets/products/Organic Fertilizers/Neem Cake Powder/image4.png";
import neemCakePowder5 from "../assets/products/Organic Fertilizers/Neem Cake Powder/image5.png";

//Organic Fertilizers - Panchagavya
import panchagavya from "../assets/products/Organic Fertilizers/Panchagavya/image1.png";
import panchagavya2 from "../assets/products/Organic Fertilizers/Panchagavya/image2.png";
import panchagavya3 from "../assets/products/Organic Fertilizers/Panchagavya/image3.png";

//Organic Fertilizers - Vermicompost
import vermicompost from "../assets/products/Organic Fertilizers/Vermicompost/image.png";
import vermicompost1 from "../assets/products/Organic Fertilizers/Vermicompost/image1.png";
import vermicompost2 from "../assets/products/Organic Fertilizers/Vermicompost/image2.png";
import vermicompost3 from "../assets/products/Organic Fertilizers/Vermicompost/image3.png";


export const productSections = [
    {
        title: "Cocopeat Blocks",
        description:
            "We at Natural Cocos manufacture and market Cocopeat in various sizes according to customer's requirement. CoirPith / Cocopeat is washed, heat-treated, screened and graded before being processed into cocopeat products of various granularity and density.",
            //"Pioneers in the industry, we offer 5 Kg High Ec Cocopeat Block, 5kg Low EC Coir Pith Block, Coco Peat 650 Grams Low EC, Coco Peat 650 Grams High EC and High ec Coco Peat 5kg block (Unseived) from India.",
            products: [
            {
                name: "5 Kg", //husk chips blocks
                images: [block5a, block5b, block5c, block5d, block5e, block5f, block5g, block5h, block5i, block5j, chips1, chips2, chips3, chips4, chips5, chips6],
            },
            {
                name: "2 Kg",
                images: [block2a, block2b, block2c],
            },
            {
                name: "1 Kg",
                images: [block1a, block1b, block1c, block1d, block1e],
            },
            {
                name: "650g", //similar to 5Kg
                images: [block650g, block650g2, block650g3, block650g4, block650g5, block650g6, block650g7, block650g8],
            },
        ],
    },
    {
        title: "Coir Fibre",
        description:
            "We at Natural Cocos manufacture and supply high-quality Coir Fibre in various grades and bale sizes as per customer requirements. Our Coir Fibre is extracted from matured coconut husks, thoroughly cleaned, and processed to ensure strength, durability, and consistency. It is widely used in rope making, mattress and brush manufacturing, erosion control, and as a natural soil amendment for horticulture and agriculture.",
        products: [
            {
                name: "120 Kg Bale",
                images: [coirFibre120Kg, coirFibre120Kg2, coirFibre120Kg3, coirFibre120Kg4],
            },
            {
                name: "30 Kg Bale",
                images: [coirFibre30Kg, coirFibre30Kg2, coirFibre30Kg3, coirFibre30Kg4],
            },
        ],
    },
    {
        title: "Coir Yarn",
        description:
            "We at Natural Cocos manufacture and supply a wide range of Coir Yarn products, crafted from high-quality coconut coir fiber. Our coir yarns are available in various ply, thicknesses, and lengths to suit diverse applications in agriculture, packaging, crafts, marine, and construction. Naturally strong, flexible, and biodegradable, our coir yarn is an eco-friendly solution for tying, binding, weaving, and more.",
        products: [
            {
                name: "2 Ply 7 mm",
                images: [
                    ply7mm22_2, ply7mm22_1, ply7mm22_3, ply7mm22_4, ply7mm22_5, ply7mm22_6, ply7mm22_7, ply7mm22_8, ply7mm22_9, ply7mm22_10, ply7mm22_11, ply7mm22_12, ply7mm22_13, ply7mm22_14, ply7mm22_15,
                    ply7mm30_1, ply7mm30_2, ply7mm30_3, ply7mm30_4, ply7mm30_5
                ],
            },
            {
                name: "2 Ply 5 mm",
                images: [ply5mm_1, ply5mm_2, ply5mm_3, ply5mm_4, ply5mm_5],
            },
            {
                name: "2 Ply 4 mm",
                images: [ply4mm_1, ply4mm_2, ply4mm_3, ply4mm_4, ply4mm_5, ply4mm_6, ply4mm_7, ply4mm_8, ply4mm_9],
            },
            {
                name: "2 Ply 3 mm",
                images: [ply3mm_1, ply3mm_2, ply3mm_3, ply3mm_4, ply3mm_5, ply3mm_6, ply3mm_7, ply3mm_8, ply3mm_9, ply3mm_10],
            },
            {
                name: "2 Ply 15 Feet / 18 Feet (Double Piece)",
                images: [doublePiece1, doublePiece2, doublePiece3, doublePiece4, doublePiece5, doublePiece6, doublePiece7, doublePiece8, doublePiece9, doublePiece10, doublePiece11, doublePiece12],
            },
            {
                name: "3 Ply 15 Feet / 18 Feet",
                images: [ply3_15_18_1, ply3_15_18_2, ply3_15_18_3, ply3_15_18_4, ply3_15_18_5, ply3_15_18_6],
            },
            {
                name: "Loose Twisted Spooling Coir Yarn",
                images: [looseTwisted1, looseTwisted2, looseTwisted3],
            },
        ],
    },
    {
        title: "Coir Rope",
        description:
            "We at Natural Cocos manufacture and supply high-quality Coir Rope, crafted from natural coconut coir fiber. Our coir ropes are available in various thicknesses and lengths, suitable for diverse applications in agriculture, packaging, crafts, marine, and construction. Naturally strong, flexible, and biodegradable, our coir rope is an eco-friendly solution for tying, binding, weaving, and more.",
        products: [
            {
                name: "8 Ply / 10 Ply (Vadam)",
                images: [vadam1, vadam2, vadam3],
            },
        ]
    },
    {
        title: "Cocopeat Powder",
        description:
            "Give your 🌴plants/trees the best care with our Coco Peat Powder, made from natural coconut husks. It’s soft, clean, and full of goodness for the soil. Whether you are a farmer, gardener, or home grower – this is the perfect helper for growing strong, green plants.",
        products: [
            {
                name: "Loose Powder",
                images: [loosePowder, loosePowder2, loosePowder3, loosePowder4],
            },
            {
                name: "25 Kg Bale",
                images: [cocopeatPowder25Kg1, cocopeatPowder25Kg2, cocopeatPowder25Kg3, cocopeatPowder25Kg4],
            },
        ],
    },
    {
        title: "Organic Fertilizers",
        description:
            "We at Natural Cocos offer a range of organic fertilizers, including Fish Amino Acid, Neem Cake Powder, Panchagavya, and Vermicompost. These fertilizers are made from natural ingredients and are designed to enhance soil fertility, promote healthy plant growth, and improve crop yields. Our products are eco-friendly, sustainable, and suitable for various agricultural and horticultural applications.",
        products: [
            {
                name: "Vermicompost",
                images: [vermicompost, vermicompost1, vermicompost2, vermicompost3],
            },
            {
                name: "Fish Amino Acid",
                images: [fishAminoAcid, fishAminoAcid2, fishAminoAcid3, fishAminoAcid4, fishAminoAcid5, fishAminoAcid6, fishAminoAcid7, fishAminoAcid8, fishAminoAcid9, fishAminoAcid10],
            },
            {
                name: "Neem Cake Powder",
                images: [ncp1, neemCakePowder, neemCakePowder2, neemCakePowder3, neemCakePowder3a, neemCakePowder4, neemCakePowder5],
            },
            {
                name: "Panchagavya",
                images: [panchagavya, panchagavya2, panchagavya3],
            },
        ],
    },
    //(same cateogry)
    //Custom Cocopeat Mixes with Coconut Husk Chips
    //You can request any mix ratio based on:
    // {
    //     title: "Grow Bags/Slabs",
    //     description:
    //         "Prominent & Leading Wholesaler from Salem, we offer 6Mm 30Inches Coir Rope (Rollmudi), 5Mm 48 Inches CoirYarn (Magadan), 2Ply 6Mm Coir Yarn (Rollmudi) and 2 Ply Golden Brown Coir Yarn.",
    //     products: [
    //         {
    //             name: "Grow Bags/Slabs",
    //             images: [image1],
    //         },
    //     ],
    // },
    // {
    //     title: "Coir Pots",
    //     description:
    //         "Prominent & Leading Wholesaler from Salem, we offer 6Mm 30Inches Coir Rope (Rollmudi), 5Mm 48 Inches CoirYarn (Magadan), 2Ply 6Mm Coir Yarn (Rollmudi) and 2 Ply Golden Brown Coir Yarn.",
    //     products: [
    //         {
    //             name: "Coir Pots",
    //             images: [image1],
    //         },
    //     ],
    // },
    // {
    //     title: "Coco Peat Discs",
    //     description:
    //         "Coir discs, also known as coir coins or coir pith discs, are small, round discs made from coconut coir fiber.",
    //     products: [
    //         {
    //             name: "Coir Discs (Coins)",
    //             images: [image1],
    //         },
    //     ],
    // },
];
